import script from "./SubsidiaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubsidiaryView.vue?vue&type=script&setup=true&lang=js"

import "./SubsidiaryView.vue?vue&type=style&index=0&id=637667f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637667f8"]])

export default __exports__